// extracted by mini-css-extract-plugin
module.exports = {"link":"_25Jq6","aside":"_37uCZ","title":"DnpzY","list":"tVMNF","listItem":"_3pGmJ","listContainer":"_2JhU3","background":"_3Vp4t","fadeIn":"kPYAs","expand":"_36UzS"};